module.exports = __webpack_public_path__ + "img/contact.451bae92.svg";